import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Visibility from "@material-ui/icons/Visibility";
import {
  IconButton
} from "@material-ui/core";
import axios from "axios";
import envConfig from "../../../bin/env.config";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
 
}));



export default function ButtonHidden({ product, reloadData }) {
  const classes = useStyles();
  const [isOnChange, setIsOnChange] = useState(false);
  const token = useSelector((state) => state.session.token);

  const handleOnHide = () => {
    setIsOnChange(true);
  };
  
  useEffect(() => {
    const serverUpdate = async () => {     
      const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/hide-product/${product.id}`;
      const result = await axios.put(url, {}, {
        headers: {
          Authorization: JSON.stringify(token),
        },
      });
      setIsOnChange(false)
      reloadData()     
    };
    if (isOnChange && product?.id) {
      serverUpdate();
    }
  }, [isOnChange, product, token, reloadData]);
  
  return (
    <>
      {product && (
        <IconButton size='small' onClick={handleOnHide}
        alt="Hide this product"
        title="Hide this product"
        >
          {product.is_hidden ? <VisibilityOff/> : <Visibility/>}
        </IconButton>      
      )}     
      
    </>
  );
}
